import journalProfitRequest from "./requests/journal-profit-request";
import getStatRequest from "./requests/get-stat-request";

const statisticsRepository = {
    journalProfit: journalProfitRequest,
    getStat: getStatRequest,
};

export default statisticsRepository;